import bButton from 'bootstrap-vue/es/components/button/button';

var pyButton = {
  extends: bButton
}

export default pyButton;
